import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Section, LinkButton } from '../../shared/components';
import useServiceReducer from '../../shared/hooks/useServiceReducer';
import dashboardService from '../../services/dashboardService';
import reducer, { DashboardAction } from './reducer';
import { DashboardFilter } from '../../services/types/Dashboard';
import GanttView from './GanttView';
import ListView from './ListView';
import Bar from './Bar';
import SessionContext from '../App/SessionProvider/context';

// For now, Dashboard redirects to Operations
const TaskPanel: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    dashboard: { currentFilter, saveFilter },
  } = useContext(SessionContext);

  const serviceWrapper = async (filter: DashboardFilter) => {
    saveFilter(filter);
    return dashboardService.list(filter);
  };

  const hook = useServiceReducer(serviceWrapper, reducer, currentFilter);
  const [data, loading, filter, dispatch] = hook;

  const send = (type: string, rest?: Record<string, unknown>) => {
    const action = { type, ...rest } as DashboardAction;
    dispatch(action);
  };

  return (
    <Section
      title={filter.ganttMode ? t('ganttView') : t('listView')}
      titleButton={
        <LinkButton onClick={() => navigate(`/operations`)} text={t('seeAllOperations')} />
      }
    >
      <Bar filter={filter} send={send} periodText={data && data.periodText} />
      {filter.ganttMode ? (
        data && <GanttView data={data} filter={filter} loading={loading} />
      ) : (
        <ListView hook={hook} send={send} />
      )}
    </Section>
  );
};

export default TaskPanel;
